// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import classNames from "classnames";
import IconButton from "./IconButton.jsx";

/**
 * @param {Object}   props
 * @param {Object}   props.annotation
 * @param {boolean}  props.isEditable
 * @param {boolean}  props.disabled
 * @param {function} props.onClickCitation
 * @return {HTMLElement}
 */
const CitationButton = props => {
	const {annotation, isSidebarApiClosed = true} = props;

	const citationApproved = annotation.citation && annotation.citation.approved === true;

	let tooltipText;

	const viewCitationOnly = citationApproved || !props.isEditable;
	if (viewCitationOnly)
		tooltipText = "View Citation";
	else
		tooltipText = "Confirm Citation";

	// The Sidebar API is being used, but the sidebar is currently closed. The
	// user needs to open the sidebar themselves to see the citation.
	if (isSidebarApiClosed) {
		if (viewCitationOnly)
			tooltipText = "Open sidebar to view citation";
		else
			tooltipText = "Open sidebar to view or edit citation";
	}

	return <IconButton
		className="aa-btn-general aa-btn-ext-icon js-aa-citation-btn"
		disabled={props.disabled}
		icon={classNames({
			"aa-icon-citation-outline": !citationApproved,
			"aa-icon-citation-solid":   citationApproved
		})}
		onClick={() => props.onClickCitation(annotation.uuid)}
		showToolTip={props.showToolTip}
		tippyOptions={{placement: "bottom"}}
		tooltipText={tooltipText}
	/>;
};

export default CitationButton;
